// extracted by mini-css-extract-plugin
export default {"container":"Competition_container__rvrUW","card":"Competition_card__6oBcQ","noEvents":"Competition_noEvents__AdIIq"};